import type { CustomSettingConfig } from '@/_pages/system-users/shared/custom-settings/types';

import { permissibleRouteKeys } from './permissible-route-keys';
import { navigationShortcutsSchema, type NavigationShortcutsSchema } from './schema';

const getDefaultRoutsSettings = () => permissibleRouteKeys.options.map((item, i) => ({ id: item, sortOrder: i }));

export const NAVIGATION_SHORTCUTS_CONFIG: CustomSettingConfig<NavigationShortcutsSchema> = {
  name: 'navigation_shortcuts',
  defaultValue: getDefaultRoutsSettings(),
  schema: navigationShortcutsSchema,
};
